import type { WithInherit, Direction } from '@wix/editor-elements-common-utils';

const alignmentMapPhysicalToLogical: Record<
  string,
  (direction: WithInherit<Direction>) => string
> = {
  left: direction => (direction === 'rtl' ? 'end' : 'start'),
  right: direction => (direction === 'rtl' ? 'start' : 'end'),
};

export const physicalToLogicalAlignment = (
  alignment: string,
  direction: WithInherit<Direction>,
): string => {
  return alignmentMapPhysicalToLogical[alignment]?.(direction) ?? alignment;
};
